import React, { useCallback, useState } from "react";
import { Card, Button, Col, Row, CardBody, CardFooter } from "reactstrap";
import closeOutline from "../../../assets/icons/close-outline.svg";
import store from "../../../assets/icons/store.svg";

import I18n from "../../../../i18n/utils";
import CFASpinner from "../../Common/CFASpinnner/CFASpinner";
import "./riskInformationResetModal.scss";
import { fetchAllRefundAnalysisInformation } from "../../../redux/features/refundAnalysisSlice";
import { useDispatch } from "react-redux";
import { getOktaUser } from "../../../utils/LocalStorage";

function RiskInformationResetModal(props: any) {
  const dispatch = useDispatch();
  const oktaUserInfo = getOktaUser();

  function modifiedScoreCount() {
    let modifiedScoreCount = 0;
    for (const [key, value] of props.riskRecordsModified.current) {
      for (const score of value) {
        modifiedScoreCount++;
      }
    }
    return modifiedScoreCount;
  }

  function submit() {
    let startDateRaw = new Date();
    startDateRaw.setDate(startDateRaw.getDate() - 30);
    const startDate = startDateRaw.toISOString().split("T")[0];

    let endDateRaw = new Date();
    endDateRaw.setDate(endDateRaw.getDate());
    const endDate = endDateRaw.toISOString().split("T")[0];

    const userEmail = oktaUserInfo[1];
    const params = { userEmail, startDate, endDate };
    dispatch(fetchAllRefundAnalysisInformation(params));
    props.riskRecordsModified.current.clear();
    props.close(true);
  }
  const close = useCallback(() => {
    props.close(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetForm = (
    <Row>
      <Col className="dashboard-card">
        <Card className="dashboard-card">
          <CardBody>
            <Row className="close-button-container">
              <img
                alt=""
                src={closeOutline}
                className="close-modal-icon"
                onClick={close}
              />
            </Row>
            <Row className="container">
              <Col className="bu-override-import-title-container">
                <img
                  alt=""
                  src={store}
                  className="bu-override-import-title-icon"
                />
                <h2 className="bu-override-import-title">
                  {I18n.t("RISK_ANALYSIS_RESET_MODAL_TITLE")}
                </h2>
              </Col>
            </Row>
            <Row className="input-row">
              <h3>
                {" "}
                There {modifiedScoreCount() === 1 ? "is" : "are"}{" "}
                {modifiedScoreCount()} modified{" "}
                {modifiedScoreCount() > 1 || modifiedScoreCount() == 0
                  ? "records"
                  : "record"}{" "}
              </h3>
            </Row>
            <CardFooter>
              {!props.loading ? (
                <Row>
                  <>
                    <Button
                      disabled={
                        props.riskRecordsModified.current == undefined ||
                        props.riskRecordsModified.current.size == 0 ||
                        props.userEmailValidated == false
                      }
                      className="submit-button"
                      onClick={submit}
                    >
                      {I18n.t(
                        "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_RESET_TEXT"
                      )}
                    </Button>
                    <Button className="submit-button" block onClick={close}>
                      Close
                    </Button>
                  </>
                </Row>
              ) : (
                <Row className="spinner-container">
                  <CFASpinner />
                </Row>
              )}
            </CardFooter>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );

  return (
    <>
      <Col className="RiskInformationResetModal container">
        <> {resetForm} </>
      </Col>
    </>
  );
}
export default RiskInformationResetModal;
